import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { resolveAssetUrl } from "../../utils/assetUrl";

var StoricoOrdini = /*#__PURE__*/function (_Vue) {
  _inherits(StoricoOrdini, _Vue);

  var _super = _createSuper(StoricoOrdini);

  function StoricoOrdini() {
    var _this;

    _classCallCheck(this, StoricoOrdini);

    _this = _super.apply(this, arguments);
    _this.findModel = "";
    _this.findRef = "";
    _this.findFrontColor = "";
    _this.findDate = "";
    _this.page = 1;
    _this.pageSize = 5;
    _this.pageSizes = [5, 10, 20, 50, 100];
    _this.height = 0;
    _this.historyLoading = false;
    _this.visOrd = false;
    _this.details = []; // data: "";

    _this.idDetails = 0;
    _this.persDialog = false;
    _this.detailsLensDialog = false;
    _this.pers = [];
    _this.dettaglioOrdineLente = [];
    return _this;
  }

  _createClass(StoricoOrdini, [{
    key: "asset",
    value: function asset(path) {
      return resolveAssetUrl(path);
    }
  }, {
    key: "storicoOrdiniDialog",
    get: function get() {
      return this.$store.state.storicoOrdiniDialog;
    }
  }, {
    key: "orderHistory",
    get: function get() {
      return this.$store.state.configurator.user.orderHistory;
    }
  }, {
    key: "pagedHistoryRows",
    get: function get() {
      if (this.orderHistory != null) {
        this.historyLoading = false;
        return this.filteredByFilter.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
      } else {
        this.historyLoading = true;
      }

      return [];
    }
  }, {
    key: "heightTableBody",
    get: function get() {
      return this.pageSize * 60 + 71 + 1; // 60 è l'altezza delle righe della tabella impostata nel row-style, 71 è l'altezza dell'header
    }
  }, {
    key: "filteredByFilter",
    get: function get() {
      var _this2 = this;

      var filtered = [];

      if (this.orderHistory) {
        filtered = this.orderHistory.filter(function (det) {
          // return det.Notes && det.Notes.indexOf(this.findRef) >= 0;
          var hasModel = det.details.filter(function (c) {
            return c.COD_PROD.indexOf(_this2.findModel) >= 0 && c.Note.indexOf(_this2.findRef) >= 0 && c.COLORE.indexOf(_this2.findFrontColor) >= 0;
          });
          return hasModel[0];
        });

        if (this.findDate != null) {
          filtered = filtered.filter(function (c) {
            return c.date.indexOf(_this2.findDate) >= 0;
          });
        } else {
          return filtered;
        }
      }

      return filtered;
    } // get filteredByFilter() {
    //   let queryFilter: JsLinq<any> = jslinq(this.orderHistory);
    //   let filtered = queryFilter.where!((det: any) => {
    //     let hasModel = jslinq(det.details).any!((c: any) => {
    //       return (
    //         c.COD_PROD.indexOf(this.findModel) >= 0 &&
    //         c.Note.indexOf(this.findRef) >= 0 &&
    //         c.COLORE.indexOf(this.findFrontColor) >= 0
    //       );
    //     });
    //     // return hasModel && det.date.indexOf(this.findDate) >= 0;
    //     return hasModel;
    //   });
    //   // .where((c) => {
    //   //   return c.date.indexOf(this.findDate) >= 0;
    //   // })
    //   // .toList();
    //   if (this.findDate != null) {
    //     filtered = (filtered as any).where!((c: any) => {
    //       return c.date.indexOf(this.findDate) >= 0;
    //     }).toList();
    //   } else {
    //     filtered = (filtered as any).toList();
    //   }
    //   return filtered;
    // }

  }, {
    key: "mounted",
    value: function mounted() {
      this.$store.dispatch("configurator/user/getUserHistory");
    }
  }, {
    key: "closeStoricoOrdiniDialog",
    value: function closeStoricoOrdiniDialog(cso) {
      this.$store.commit("openCloseStoricoOrdiniDialog", cso);
    }
  }, {
    key: "openOrderDetails",
    value: function openOrderDetails(order) {
      this.visOrd = true;
      this.details = order.details;
    }
  }, {
    key: "hasIncisione",
    value: function hasIncisione(row) {
      return [row.nome, row.EST_ASTA_SX_NOME, row.INT_ASTA_SX_NOME, row.EST_ASTA_DX_NOME, row.INT_ASTA_DX_NOME, row.CIL_DX_NOME, row.CIL_SX_NOME].some(function (value) {
        return String(value || "").trim() !== "";
      });
    }
  }, {
    key: "getOrderNotes",
    value: function getOrderNotes(order) {
      return this.firstNotEmpty(order.Notes, order.notes, order.Note, order.note);
    }
  }, {
    key: "getRowReference",
    value: function getRowReference(row) {
      return this.firstNotEmpty(row.Note, row.note, row.reference, row.Reference);
    }
  }, {
    key: "getRowNotes",
    value: function getRowNotes(row) {
      return this.firstNotEmpty(row.Notes, row.notes);
    }
  }, {
    key: "firstNotEmpty",
    value: function firstNotEmpty() {
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }

      var found = values.find(function (value) {
        return String(value || "").trim() !== "";
      });
      return found == null ? "" : String(found);
    }
  }, {
    key: "setSizePage",
    value: function setSizePage(val) {
      this.pageSize = val;
    }
  }, {
    key: "setPage",
    value: function setPage(val) {
      this.page = val;
    }
  }, {
    key: "totalOrder",
    get: function get() {
      if (this.orderHistory) {
        return this.orderHistory.length;
      } else {
        return 0;
      }
    }
  }, {
    key: "getRowClass",
    value: function getRowClass(data) {
      return data.row.nome === "" ? "hidden" : "";
    }
  }, {
    key: "personaliz",
    value: function personaliz(id_riga) {
      var _this3 = this;

      if (this.pers.length == 0) {
        this.details.forEach(function (e) {
          if (e.ID_RIGA == id_riga) {
            var _this3$pers;

            (_this3$pers = _this3.pers).push.apply(_this3$pers, [{
              label: "FRONTALE",
              nome: e.nome,
              coloreTesto: e.colore_nome,
              fontTesto: e.font_nome
            }, {
              label: "ESTERNO ASTA SINISTRA",
              nome: e.EST_ASTA_SX_NOME,
              coloreTesto: e.EST_ASTA_SX_COLORE_NOME,
              fontTesto: e.EST_ASTA_SX_FONT_NOME
            }, {
              label: "INTERNO ASTA SINISTRA",
              nome: e.INT_ASTA_SX_NOME,
              coloreTesto: e.INT_ASTA_SX_COLORE_NOME,
              fontTesto: e.INT_ASTA_SX_FONT_NOME
            }, {
              label: "ESTERNO ASTA DESTRA",
              nome: e.EST_ASTA_DX_NOME,
              coloreTesto: e.EST_ASTA_DX_COLORE_NOME,
              fontTesto: e.EST_ASTA_DX_FONT_NOME
            }, {
              label: "INTERNO ASTA DESTRA",
              nome: e.INT_ASTA_DX_NOME,
              coloreTesto: e.INT_ASTA_DX_COLORE_NOME,
              fontTesto: e.INT_ASTA_DX_FONT_NOME
            }].concat(_toConsumableArray(e.CIL_DX_NOME && e.CIL_DX_NOME.trim() !== "" ? [{
              label: "CILIARE DESTRO",
              nome: e.CIL_DX_NOME,
              coloreTesto: e.CIL_DX_COLORE_NOME,
              fontTesto: e.CIL_DX_FONT_NOME
            }] : []), _toConsumableArray(e.CIL_SX_NOME && e.CIL_SX_NOME.trim() !== "" ? [{
              label: "CILIARE SINISTRO",
              nome: e.CIL_SX_NOME,
              coloreTesto: e.CIL_SX_COLORE_NOME,
              fontTesto: e.CIL_SX_FONT_NOME
            }] : [])));
          }
        });
      } else {
        this.pers = [];
        this.details.forEach(function (e) {
          if (e.ID_RIGA == id_riga) {
            var _this3$pers2;

            (_this3$pers2 = _this3.pers).push.apply(_this3$pers2, [{
              label: _this3.$t("message.frontale").toUpperCase(),
              nome: e.nome,
              coloreTesto: e.colore_nome,
              fontTesto: e.font_nome
            }, {
              label: _this3.$t("message.esterno").toUpperCase() + " " + _this3.$t("message.Asta_sinistra").toUpperCase(),
              nome: e.EST_ASTA_SX_NOME,
              coloreTesto: e.EST_ASTA_SX_COLORE_NOME,
              fontTesto: e.EST_ASTA_SX_FONT_NOME
            }, {
              label: _this3.$t("message.interno").toUpperCase() + " " + _this3.$t("message.Asta_sinistra").toUpperCase(),
              nome: e.INT_ASTA_SX_NOME,
              coloreTesto: e.INT_ASTA_SX_COLORE_NOME,
              fontTesto: e.INT_ASTA_SX_FONT_NOME
            }, {
              label: _this3.$t("message.esterno").toUpperCase() + " " + _this3.$t("message.Asta_destra").toUpperCase(),
              nome: e.EST_ASTA_DX_NOME,
              coloreTesto: e.EST_ASTA_DX_COLORE_NOME,
              fontTesto: e.EST_ASTA_DX_FONT_NOME
            }, {
              label: _this3.$t("message.interno").toUpperCase() + " " + _this3.$t("message.Asta_destra").toUpperCase(),
              nome: e.INT_ASTA_DX_NOME,
              coloreTesto: e.INT_ASTA_DX_COLORE_NOME,
              fontTesto: e.INT_ASTA_DX_FONT_NOME
            }].concat(_toConsumableArray(e.CIL_DX_NOME && e.CIL_DX_NOME.trim() !== "" ? [{
              label: (_this3.$t("message.Ciliare_destro") || "CILIARE DESTRO").toUpperCase(),
              nome: e.CIL_DX_NOME,
              coloreTesto: e.CIL_DX_COLORE_NOME,
              fontTesto: e.CIL_DX_FONT_NOME
            }] : []), _toConsumableArray(e.CIL_SX_NOME && e.CIL_SX_NOME.trim() !== "" ? [{
              label: (_this3.$t("message.Ciliare_sinistro") || "CILIARE SINISTRO").toUpperCase(),
              nome: e.CIL_SX_NOME,
              coloreTesto: e.CIL_SX_COLORE_NOME,
              fontTesto: e.CIL_SX_FONT_NOME
            }] : [])));
          }
        });
      }

      this.persDialog = true;
    }
  }, {
    key: "setDettaglioOrdineLente",
    value: function setDettaglioOrdineLente(row) {
      if (row.LENSRIGHT != "" && row.LENSLEFT != "") {
        if (this.dettaglioOrdineLente.length == 0) {
          // TODO: inserire tipo CartRow al posto di any quando inseriremo il campo id su CartRow su cfg-base-app
          this.dettaglioOrdineLente.push({
            label: this.$t("message.Lente_destra").toUpperCase(),
            lens: row.LENSRIGHT,
            lensModel: row.LENSRIGHTDESCR,
            reference: row.Note,
            notes: row.Note,
            lensestype: "MONOFOCALE",
            sfera: row.SPHRIGHT,
            cilindro: row.CYLRIGHT,
            asse: row.AXISRIGHT,
            semiDist: row.PDRIGHT,
            altPup: row.HEIGHTRIGHT,
            add: row.ADDRIGHT
          }, {
            label: this.$t("message.Lente_sinistra").toUpperCase(),
            lens: row.LENSLEFT,
            lensModel: row.LENSLEFTDESCR,
            reference: row.Note,
            notes: row.Note,
            lensestype: "MONOFOCALE",
            sfera: row.SPHLEFT,
            cilindro: row.CYLLEFT,
            asse: row.AXISLEFT,
            semiDist: row.PDLEFT,
            altPup: row.HEIGHTLEFT,
            add: row.ADDLEFT
          });
        }

        this.detailsLensDialog = true;
      } else if (row.SUNLENS != "") {
        if (this.dettaglioOrdineLente.length == 0) {
          this.dettaglioOrdineLente.push({
            label: this.$t("message.Lente_sole").toUpperCase(),
            lens: row.SUNLENS,
            lensModel: row.SUNLENSDESCR,
            reference: row.Note,
            notes: "",
            lensestype: "",
            sfera: 0,
            cilindro: 0,
            asse: 0,
            semiDist: 0,
            altPup: 0,
            add: 0
          });
        }

        this.detailsLensDialog = true;
      }
    }
  }, {
    key: "detailsChanged",
    value: function detailsChanged(newV) {
      if (newV) {
        this.idDetails = this.details[0].ID;
      }
    }
  }, {
    key: "detailsLensDialogChanged",
    value: function detailsLensDialogChanged(newV) {
      if (newV == false) {
        this.dettaglioOrdineLente = [];
      }
    }
  }]);

  return StoricoOrdini;
}(Vue);

__decorate([Watch("details")], StoricoOrdini.prototype, "detailsChanged", null);

__decorate([Watch("detailsLensDialog")], StoricoOrdini.prototype, "detailsLensDialogChanged", null);

StoricoOrdini = __decorate([Component({})], StoricoOrdini);
export default StoricoOrdini;